module.exports = "<span>{%- data %}</span> {% if (pillDate) { %}<span class=\"q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md\">{%- pillDate %}</span>{% } %}";


//////////////////
// WEBPACK FOOTER
// ./src/pages/bulkUpload/html/createdOnTemplate.html
// module id = 1246
// module chunks = 1